var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  fill: "none",
  viewBox: "0 0 8 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#747A8E",
  strokeWidth: 2,
  d: "M7 1 2 6l5 5"
})));
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03IDFMMiA2TDcgMTEiIHN0cm9rZT0iIzc0N0E4RSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";